import { frontendURL } from '../../../helper/URLHelper';
import Index from './Index.vue';
import Show from './Show.vue';

const meta = { permissions: ['administrator', 'agent'] };

export const routes = [
  {
    path: frontendURL('accounts/:accountId/unhappy_cases'),
    name: 'unhappy_cases_index',
    component: Index,
    meta,
  },
  {
    path: frontendURL('accounts/:accountId/unhappy_cases/:id'),
    name: 'unhappy_cases_show',
    component: Show,
    meta,
  },
];

export default { routes };
